const BASE_MS = new Date('1900-01-01T00:00:00Z').getTime()
const MS_PER_DAY = 86400000

export function computeShiftId(isoDate: string, shift: string): number {
  const shiftDateMs = new Date(isoDate + 'T00:00:00Z').getTime()
  const daysDiff = Math.floor((shiftDateMs - BASE_MS) / MS_PER_DAY)
  const shiftNum = shift === 'DAY' ? 1 : shift === 'AFTERNOON' ? 2 : 3
  return daysDiff * 10 + shiftNum
}
